<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import TableHeaderCell from 'dashboard/components/widgets/TableHeaderCell.vue';
import CheckBox from 'v3/components/Form/CheckBox.vue';
import ToggleSwitch from 'dashboard/components-next/switch/Switch.vue';
import { NOTIFICATION_TYPES } from '../profile/constants';

export default {
  components: {
    TableHeaderCell,
    ToggleSwitch,
    CheckBox,
  },
  data() {
    return {
      enabled: false,
      selectedEmailFlags: [],
      selectedPushFlags: [],
      notificationTypes: NOTIFICATION_TYPES,
    };
  },
  computed: {
    ...mapGetters({
      storeEnabled: 'globalNotificationSettings/getEnabled',
      emailFlags: 'globalNotificationSettings/getSelectedEmailFlags',
      pushFlags: 'globalNotificationSettings/getSelectedPushFlags',
    }),
  },
  watch: {
    storeEnabled(value) {
      this.enabled = value;
    },
    emailFlags(value) {
      this.selectedEmailFlags = value;
    },
    pushFlags(value) {
      this.selectedPushFlags = value;
    },
  },
  mounted() {
    this.$store.dispatch('globalNotificationSettings/get');
  },
  methods: {
    checkFlagStatus(type, flagType) {
      const selectedFlags =
        type === 'email' ? this.selectedEmailFlags : this.selectedPushFlags;
      return selectedFlags.includes(`${type}_${flagType}`);
    },
    async updateSettings() {
      try {
        await this.$store.dispatch('globalNotificationSettings/update', {
          enabled: this.enabled,
          selectedEmailFlags: this.selectedEmailFlags,
          selectedPushFlags: this.selectedPushFlags,
        });
        useAlert(this.$t('GLOBAL_NOTIFICATION_SETTINGS.API.UPDATE_SUCCESS'));
      } catch (error) {
        useAlert(this.$t('GLOBAL_NOTIFICATION_SETTINGS.API.UPDATE_ERROR'));
      }
    },
    onToggleGlobal() {
      this.updateSettings();
    },
    handleInput(type, id) {
      if (type === 'email') {
        this.selectedEmailFlags = this.toggleInput(this.selectedEmailFlags, id);
      } else {
        this.selectedPushFlags = this.toggleInput(this.selectedPushFlags, id);
      }
      this.updateSettings();
    },
    toggleInput(selected, current) {
      if (selected.includes(current)) {
        return selected.filter(flag => flag !== current);
      }
      return [...selected, current];
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-6">
    <!-- Toggle global -->
    <div
      class="flex items-center justify-between w-full gap-2 p-4 border border-solid border-n-weak rounded-xl"
    >
      <div class="flex flex-col gap-1">
        <span class="text-heading-3 text-n-slate-12">
          {{ $t('GLOBAL_NOTIFICATION_SETTINGS.ENABLE.TITLE') }}
        </span>
        <span class="text-body-main text-n-slate-11">
          {{ $t('GLOBAL_NOTIFICATION_SETTINGS.ENABLE.DESC') }}
        </span>
      </div>
      <ToggleSwitch v-model="enabled" @change="onToggleGlobal" />
    </div>

    <!-- Grid: sobrepoe a preferencia individual quando habilitada -->
    <div
      class="flex flex-col"
      :class="{ 'opacity-50 pointer-events-none': !enabled }"
    >
      <div
        class="grid content-center h-12 grid-cols-12 gap-4 py-0 rounded-t-xl"
      >
        <TableHeaderCell
          :span="7"
          :label="$t('GLOBAL_NOTIFICATION_SETTINGS.TABLE.TYPE')"
        />
        <TableHeaderCell
          :span="2"
          :label="$t('GLOBAL_NOTIFICATION_SETTINGS.TABLE.EMAIL')"
        />
        <TableHeaderCell
          :span="3"
          :label="$t('GLOBAL_NOTIFICATION_SETTINGS.TABLE.PUSH')"
        />
      </div>
      <div v-for="(notification, index) in notificationTypes" :key="index">
        <div
          class="grid items-center content-center h-12 grid-cols-12 gap-4 py-0 rounded-t-xl"
        >
          <div
            class="flex flex-row items-start gap-2 col-span-7 px-0 py-2 text-sm rtl:text-right"
          >
            <span class="text-body-main text-n-slate-12">
              {{ $t(notification.label) }}
            </span>
          </div>
          <div
            v-for="(type, typeIndex) in ['email', 'push']"
            :key="typeIndex"
            class="flex items-start gap-2 px-0 text-sm text-left rtl:text-right"
            :class="`col-span-${type === 'push' ? 3 : 2}`"
          >
            <CheckBox
              :value="`${type}_${notification.value}`"
              :is-checked="checkFlagStatus(type, notification.value)"
              @update="id => handleInput(type, id)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
